module.exports = __webpack_public_path__ + "static/media/garl.5bf836ff.jpg";